// extracted by mini-css-extract-plugin
export default {"login":"styles_login__RGrjx","card":"styles_card__I4Qkr","submitButton":"styles_submitButton__aa4us"};